/** 筛选器id */
export const FilterIds = [71, 72, 73, 74, 75, 76];

/** 类目key */
export const CATEGORY_KEY = 'CM_ACCESSORY';

/** 暂存套餐信息的session storage key */
export const SESSION_COMMODITY_KEY = 'accessory_cid';

/** 标记配件推荐页来源，用于电商信息上报 */
export const RELATED_ACCESSORIES_ITEM_LIST_NAME = 'Related Accessories';

/** url上的from字段，表示跳转来源 */
export const RELATED_ACCESSORIES_FROM = 'related-accessories';
